import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom-v5-compat";

import Icon from "Atoms/Icons";

import {
  LinkButton,
  ResponsivePrimaryAction,
  ResponsiveTitleBar,
} from "../../Atoms";
import Loading, { LoadingPage, isLoading } from "../../Loading";
import { useCustomer } from "../Customer/queries";
import {
  useCurrentCustomerTab,
  useCustomerTab,
  useLoadedCustomerTab,
} from "../CustomerTab/queries";
import { useSession } from "../Session/SessionContext";
import { useCurrentBillSplit } from "./queries";

const MissingCustomerTab = () => {
  const { t } = useTranslation("onsite");
  return (
    <div className="mx-auto max-w-screen-sm space-y-64 text-center">
      <ResponsiveTitleBar>{t("billSplitError.missingTab")}</ResponsiveTitleBar>
      <div>{t("billSplitError.missingTabDescription")}</div>
      <ResponsivePrimaryAction>
        <LinkButton to="/" primary>
          {t("errors.backToMenu")}
        </LinkButton>
      </ResponsivePrimaryAction>
    </div>
  );
};
const BillSplitLayout = () => {
  const { customerTab } = useSession();
  if (!customerTab) {
    return <MissingCustomerTab />;
  }
  const { status: customerStatus } = useCustomer();
  const { status: billSplitStatus } = useCurrentBillSplit();
  const { status: customerTabStatus } = useCurrentCustomerTab();
  const loading = isLoading([
    customerStatus,
    billSplitStatus,
    customerTabStatus,
  ]);

  return (
    <div className="pb-64 md:py-24">
      {loading ? <LoadingPage /> : <Outlet />}
    </div>
  );
};

export default BillSplitLayout;
